import i18n from 'modules/core/lib/i18n'

import { OptionType } from 'modules/trainings/components/EditModeLayout/types'

export enum AvailableSections {
  basic = 'Basic',
  type = 'Type',
}

export const options = () => {
  const sections: OptionType[] = [
    {
      label: i18n.t('trainings.surveys.create.survey_type'),
      icon: 'academic-cap',
      value: AvailableSections.type,
    },
    {
      label: i18n.t('trainings.surveys.create.basic_information'),
      icon: 'file-filled',
      value: AvailableSections.basic,
    },
  ]

  return sections
}
